module.exports = __webpack_public_path__ + "img/offer_image1.2246ffe8.jpg";